import { AutoComplete } from "antd";
import { useEffect, useState } from "react";
import { apiOnSearchMember } from "../api/API";

export enum ESearchMode {
    SingleHallReservation,
    WholeHallReservation,
}

type GuestPersonAutocompleteProps = {
    onBuildGuestName?: () => string;
    onChangeGuestName: (newName: string) => void;
    value: string;
    searchMode: ESearchMode;

    style?: any;
};

export function GuestPersonAutocomplete(props: GuestPersonAutocompleteProps) {

    let [searchMemberCounter, setSearchMemberCounter] = useState<number>(0);
    let [controller, setController] = useState<AbortController>(new AbortController());
    let [searchString, setSearchString] = useState<string>(``);
    let [searchResults, setSearchResults] = useState<{ value: string, label: string }[]>([]);

    useEffect( () => {
        controller.abort();
        setController(new AbortController());
    }, [searchMemberCounter]);

    useEffect(() => {  
        if(searchString.length > 0) {
            apiOnSearchMember(searchString, props.searchMode, controller.signal)
            .then((response) => response.json())
            .then((json) => {
                let autocompleteOptions: { value: string, label: string }[] = [];

                for (const guestName of json) {
                    autocompleteOptions.push({ value: guestName, label: guestName });
                }

                setSearchResults(autocompleteOptions);                
            }).catch(reason => {
                console.log(reason);
            });
        } else {
            setSearchResults([]);
        }
    }, [searchString, controller, props.searchMode]);

    return (
        <AutoComplete style={props.style} onSearch={(string) => {
            setSearchMemberCounter(prev => prev + 1);
            setSearchString(string);                
        }} options={searchResults} onBlur={(event) => {
            setSearchResults([]);
        }} onFocus={(event) => setSearchResults([])} placeholder={props.onBuildGuestName ? props.onBuildGuestName() : ''} value={props.value} onChange={(data: string) => props.onChangeGuestName(data)} />
    );
}